import { SearchResultWithSnippet } from "./types";
import { ChatReference } from "./ChatReference";

type Props = {
  searchResults: SearchResultWithSnippet[];
  isOpen?: boolean;
  setIsOpen?: (isOpen: boolean) => void;
  urlPrefix?: string;
  linkTarget?: string;
  parentOrigin?: string;
};

export const ChatReferences = ({
  searchResults,
  urlPrefix,
  linkTarget,
  isOpen = false,
  setIsOpen = () => {
    console.log("setIsOpen");
  },
  parentOrigin,
}: Props) => {

  // Filter out dupes
  const filteredResults: SearchResultWithSnippet[] = [];
  const filteredIds: string[] = [];
  searchResults?.forEach((result) => {
    if (!filteredIds.includes(result.document_id)) {
      filteredIds.push(result.document_id);
      filteredResults.push(result);
    }
  });

  return (
    <>
      <h2 className="chatSearchResultsHeader">Recommendations:</h2>
      {filteredResults.map((result, i) => (
        <div key={i}>
          <ChatReference
            result={result}
            position={i}
            urlPrefix={urlPrefix}
            linkTarget={linkTarget}
            parentOrigin={parentOrigin}
          />
        </div>
      ))}
    </>
  );
};
